import React from 'react';
import { BLUE, RED } from '../constants/index';

const FooterText = (props) => {


  const fontStyle = {
    color: BLUE, 
    fontSize: '12px',
    fontWeight: '600'
  }
  const lineStyle = {
    color: RED, 
    fontSize: '12px',
    fontWeight: '600'
  }

  return (
    <div className='flex-vertical item-center-align'>
      <span className='flex-horizontal'>
        <h6 style={fontStyle}>CREDIT CARDS</h6> &nbsp; &nbsp;
          <h6 style={lineStyle}> | </h6> &nbsp; &nbsp;
          <h6 style={fontStyle}>PERSONAL LOANS</h6>
      </span>
      <span>
        <h6 style={fontStyle}>HOME LOANS</h6>
      </span>
      <br/>
    </div>
  );
}

export default FooterText;


// WEBPACK FOOTER //
// ./src/components/FooterText.js